import styles from "./Divider.module.scss";

export function Divider() {
  return <hr aria-hidden="true" className={styles.divider} />;
}
